export default __webpack_public_path__ + "static/media/dining-icon.5cec3362.png";